import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';

export interface MappingEngineAccount extends IAccount {
    isShifted?: boolean;
}
